import ProtectedRouter from "./context/auth/ProtectedRouter";
import { Toaster } from "./components/ui/toaster";
import { Toaster as Sonner } from "./components/ui/sonner";
import { TooltipProvider } from "./components/ui/tooltip";

import { Routes, Route, Outlet } from "react-router-dom";
import type { ComponentType } from "react";
import Index from "./pages/Index";
import LandingIndex from "./pages/dashboard/Index";
import Auth from "./pages/Auth";
import Organizations from "./pages/Organizations";
import OrganizationDetail from "./pages/OrganizationDetail";
import Channels from "./pages/Channels";
import Events from "./pages/Events";
import EventDetail from "./pages/EventDetail";
import Donations from "./pages/Donations";
import DonationDetail from "./pages/DonationDetail";
import Volunteering from "./pages/Volunteering";
import VolunteeringDetail from "./pages/VolunteeringDetail";
import Sponsorship from "./pages/Sponsorship";
import SponsorshipDetail from "./pages/SponsorshipDetail";
import Messages from "./pages/Messages";
import Directory from "./pages/Directory";
import Profile from "./pages/Profile";
import Posts from "./pages/Posts";
import NotFound from "./pages/NotFound";
import ChannelDetail from "./pages/ChannelDetail";
import ConversationDetail from "./pages/ConversationDetail";
import Notifications from "./pages/Notifications";
import Settings from "./pages/Settings";
import SOPLibrary from "./pages/SOPLibrary";
import EventTickets from "./pages/EventTickets";
import EventPayment from "./pages/EventPayment";
import MemberRegistrationPage from "./pages/MemberRegistrationPage";

type RouteConfig = {
  path?: string;
  index?: boolean;
  component: ComponentType;
  isProtected?: boolean;
};

const newDesignRouteConfig: RouteConfig[] = [
  { index: true, component: LandingIndex, isProtected: false },
  { path: "dashboard", component: LandingIndex, isProtected: false },
  { path: "home", component: Index, isProtected: true },
  { path: "auth", component: Auth, isProtected: false },
  {
    path: "Civi_Circle_Admin-mobileview/LoginPage",
    component: Auth,
    isProtected: false,
  },
  { path: "organizations", component: Organizations, isProtected: true },
  {
    path: "organizations/:id",
    component: OrganizationDetail,
    isProtected: true,
  },
  { path: "events", component: Events, isProtected: true },
  { path: "events/:id", component: EventDetail, isProtected: true },
  { path: "donations", component: Donations, isProtected: true },
  { path: "donations/:id", component: DonationDetail, isProtected: true },
  { path: "volunteering", component: Volunteering, isProtected: true },
  {
    path: "volunteering/:id",
    component: VolunteeringDetail,
    isProtected: true,
  },
  { path: "sponsorship", component: Sponsorship, isProtected: true },
  { path: "sponsorship/:id", component: SponsorshipDetail, isProtected: true },
  { path: "messages", component: Messages, isProtected: true },
  { path: "channels", component: Channels, isProtected: true },
  { path: "channels/:id", component: ChannelDetail, isProtected: true },
  {
    path: "conversations/:id",
    component: ConversationDetail,
    isProtected: true,
  },
  { path: "notifications", component: Notifications, isProtected: true },
  { path: "directory", component: Directory, isProtected: true },
  { path: "profile", component: Profile, isProtected: true },
  { path: "profiles", component: Profile, isProtected: true },
  { path: "posts", component: Posts, isProtected: true },
  { path: "settings", component: Settings, isProtected: true },
  { path: "sop-library", component: SOPLibrary, isProtected: true },
  { path: "event-tickets", component: EventTickets, isProtected: true },
  { path: "event-payment", component: EventPayment, isProtected: true },
  {
    path: "Civi_Circle_Admin-mobileview/MemberRegistrationPage",
    component: MemberRegistrationPage,
    isProtected: false,
  },
];

const publicRoutes = newDesignRouteConfig.filter(route => !route.isProtected);
const protectedRoutes = newDesignRouteConfig.filter(route => route.isProtected);


const Layout = () => (
  <div className="min-h-screen bg-background text-foreground">
    <Outlet />
  </div>
);

const renderRoute = ({ path, index, component: Component }: RouteConfig) =>
  index ? (
    <Route key="index" index element={<Component />} />
  ) : (
    <Route key={path} path={path!} element={<Component />} />
  );

const App = () => (
  <TooltipProvider>
    <Toaster />
    <Sonner />
    <Routes>
      <Route element={<Layout />}>
        {publicRoutes.map(renderRoute)}

        <Route element={<ProtectedRouter />}>
          {protectedRoutes.map(renderRoute)}
        </Route>

        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  </TooltipProvider>
);

export default App;
